<!-- 新闻动态新增编辑 -->
<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="dialogTitle"
        width="50%"
        :before-close="handleClose"
    >
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="photoUrl">
                <UploadImage
                    :width="200"
                    :height="150"
                    :maxSize="20"
                    :value.sync="form.photoUrl"
                    ref="uploadImage"
                    @on-change="handleImageChange"
                    @on-remove="handleImageRemove"
                />
            </el-form-item>
            <el-form-item label="内容" prop="info">
                <div class="editor-container">
                    <EditorDom :value.sync="form.info"></EditorDom>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="submitForm">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import EditorDom from "@/components/Editor.vue";
import { areaNewsSave, areaNewsUpdate } from "@/api/admin";

export default {
    name: "NewsForm1",
    props: ["areaType"],
    components: {
        EditorDom,
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: "新增",
            form: {
                title: "",
                info: "",
                photoUrl: "",
            },
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                info: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ],
                photoUrl: [
                    {
                        required: true,
                        message: "请上传图片",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        handleImageChange(file) {
            console.log(file);
            this.form.photoUrl = file;
        },
        handleImageRemove() {
            this.form.photoUrl = "";
        },
        handleClose() {
            this.dialogVisible = false;
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        open(row) {
            this.dialogVisible = true;
            this.dialogTitle = row ? "编辑" : "新增";
            if (row) {
                this.form = { ...row };
            } else {
                this.form = {
                    title: "",
                    info: "",
                    photoUrl: "",
                };
            }
        },
        submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        const params = {
                            ...this.form,
                            areaType: this.areaType,
                        };
                        if (this.form.id) {
                            await areaNewsUpdate(params);
                        } else {
                            await areaNewsSave(params);
                        }
                        this.$message.success("保存成功");
                        this.$emit("refresh");
                        this.dialogVisible = false;
                    } catch (error) {
                        this.$message.error(error.message || "保存失败");
                    }
                }
            });
        },
    },
};
</script>
